import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as actions from './redux/actions';
import CustomLoader from '../common/CustomLoader';
import DataForm from './collection/derived-field/DataForm';
import ListCollectionFunction from './collection/derived-field/ListCollectionFunction';
import { drapcodeIcon } from '../../common/custom/icon-library';
import ParentDocCard from '../common/ParentDocCard';
import DocsLink from '../../common/custom/DocsLink';
import CommonPageComponent from '../../common/ui/CommonPageComponent';

export class AddCollectionDerivedField extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, collectionId, version } = match.params;
    actions.loadProjectCollectionDetail({ projectId, collectionId, version });
    actions.loadProjectCollections({ projectId, version });
    actions.loadProjectDetailCollections({ projectId, version });
  }

  render() {
    const { actions, collections, match } = this.props;
    const {
      loadProjectCollectionDetailPending,
      selectedCollection,
      addUtilityFunctionToCollectionPending,
      deleteUitilityFunctionPending,
      projectCollections,
      items,
      projectDetail,
    } = collections;
    const { projectId, collectionId, version } = match.params;
    return (
      <CommonPageComponent parentClassName="">
        <div className="row mx-auto">
          <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
            {loadProjectCollectionDetailPending && (
              <div className="text-center">
                <CustomLoader
                  loading={loadProjectCollectionDetailPending}
                  size="20px"
                  color="#303453"
                />
              </div>
            )}
            {selectedCollection && (
              <>
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                    <div className="card">
                      <div
                        className="card-header card-header-icon"
                        data-background-color="drapcode-dark-blue"
                      >
                        <i className={`wb ${drapcodeIcon('form')}`}></i>
                      </div>
                      <div className="card-content">
                        <div className="card-title-header">
                          <h5 className="card-title">
                            Add Derived Field
                            {typeof selectedCollection !== 'undefined' && selectedCollection
                              ? ' To ' + selectedCollection.collectionTitle
                              : ''}
                          </h5>
                          <div className="card-cta"></div>
                        </div>
                        <DataForm
                          actions={actions}
                          commonActions={commonActions}
                          version={version}
                          projectId={projectId}
                          collection={selectedCollection}
                          collections={projectCollections}
                          showDerivedFieldCreateLoader={addUtilityFunctionToCollectionPending}
                          projectDetail={projectDetail}
                          refCollectionItems={items}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 drapcode">
                    <div className="card">
                      <div
                        className="card-header card-header-icon"
                        data-background-color="drapcode-dark-blue"
                      >
                        <i className={`wb ${drapcodeIcon('list')}`}></i>
                      </div>
                      <div className="card-content">
                        <div className="card-title-header">
                          <h5 className="card-title">Derived Fields</h5>
                          <div className="card-cta"></div>
                        </div>
                        <ListCollectionFunction
                          utilities={selectedCollection.utilities}
                          actions={actions}
                          commonActions={commonActions}
                          projectId={projectId}
                          version={version}
                          collection={selectedCollection}
                          showUtilityDeleteLoader={deleteUitilityFunctionPending}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="row">
                      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12"></div>
                      <div className="col-md-6 col-lg-6 col-sm-12 col-xs-12 pt-4 text-right">
                        <Link
                          className="btn btn-primary btn-md"
                          to={`/collections/${version}/v/${projectId}/add-filters/${collectionId}`}
                          title="Goto Next Step to Add Filters"
                        >
                          <i className="wb webconnect-skip-forward-fill"></i> Goto Add Filters
                        </Link>
                        <Link
                          className="btn btn-primary btn-md"
                          to={`/collections/${version}/v/${projectId}/add-item/${collectionId}`}
                          title="Goto Next Step to Add Data"
                        >
                          <i className="wb webconnect-skip-forward-fill"></i> Add Data
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <ParentDocCard>
            <h5>About Derived Fields</h5>
            <p>
              After adding fields in your collection, add derived fields, if you want. A derived
              field is a field that does computations on existing fields to generate derived values.
            </p>
            <br />
            <DocsLink link="https://academy.drapcode.com/docs/app-derived-fields/derived-fields-in-collection" />
          </ParentDocCard>
        </div>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    commonActions: bindActionCreators({ ...commonActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCollectionDerivedField);
